import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import React, { createContext, useCallback, useContext, useState } from "react";

export const AlertContext = createContext();

const AUTO_DISMISS_MS = 4000;

export function AlertProvider({ children }) {
  const [alerts, setAlerts] = useState([]);

  const addAlert = useCallback((content, severity) => {
    setAlerts((alerts) => [{ content, severity, open: true }, ...alerts]);
  }, []);

  const addSuccessAlert = useCallback((alertContent) => addAlert(alertContent, "success"), [addAlert]);
  const addInfoAlert = useCallback((alertContent) => addAlert(alertContent, "info"), [addAlert]);
  const addWarningAlert = useCallback((alertContent) => addAlert(alertContent, "warning"), [addAlert]);
  const addErrorAlert = useCallback((alertContent) => addAlert(alertContent, "error"), [addAlert]);

  const value = { addSuccessAlert, addInfoAlert, addWarningAlert, addErrorAlert };

  return (
    <AlertContext.Provider value={value}>
      {children}
      {alerts.map((alert, i) => (
        <Snackbar
          open={alert.open}
          key={i}
          onClose={() => {
            // set open to false for nice exit transition, then delete alert after one second
            const updatedAlerts = [...alerts];
            updatedAlerts.find((currentAlert) => currentAlert === alert).open = false;
            setAlerts(updatedAlerts);
            setTimeout(() => setAlerts((alerts) => alerts.slice(0, alerts.length - 1)), 1000);
          }}
          autoHideDuration={alert.severity === "error" ? AUTO_DISMISS_MS * 2 : AUTO_DISMISS_MS}
        >
          <Alert variant="filled" severity={alert.severity}>
            {alert.content}
          </Alert>
        </Snackbar>
      ))}
    </AlertContext.Provider>
  );
}

// Define a custom "hook" to get these alert functions!
const useAlerts = () => useContext(AlertContext);
export default useAlerts;
